// extracted by mini-css-extract-plugin
export default {"bar":"Progress_bar__RL0+v","accent":"Progress_accent__Of04J","percent":"Progress_percent__pU1im","label":"Progress_label__z4H+J","minmax":"Progress_minmax__5D2kw"};